module.exports = __webpack_public_path__ + "static/media/img73.1a346d63.jpg";